// https://supabase.com/docs/reference/javascript/insert
// import { supabase, parseRes } from '@/utils/api/db/config'

export default {
  /* eslint sort-keys: "error" */
}
